import { Button } from "@/components/ui/button";
import { Container } from "@/components/ui/container";

type PublicNavBarProps = {
  logoLabel: string;
  ctaLabel: string;
  onCta: () => void;
};

export default function PublicNavBar({
  logoLabel,
  ctaLabel,
  onCta,
}: PublicNavBarProps) {
  return (
    <nav className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-md safe-top">
      <Container className="flex h-16 items-center justify-between">
        <span className="text-xl font-bold text-foreground">{logoLabel}</span>
        <Button type="button" variant="gradient" size="sm" onClick={onCta}>
          {ctaLabel}
        </Button>
      </Container>
    </nav>
  );
}
